import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { GooglePlaceDirective } from 'node_modules/ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';

@Component({
  selector: 'app-add-buy-get-action',
  templateUrl: './add-buy-get-action.component.html',
  styleUrls: ['./add-buy-get-action.component.css'],
})
export class AddBuyGetActionComponent implements OnInit {
  public form: FormGroup;
  spinnerType = SPINNER.circle;
  public submitted = false;
  public termsAndConditions: any;
  public addModel: any;
  actionModel: NgbModalRef;
  public addAndBuyAction: any;
  public addAndBuyActions: any;
  actions: FormArray;
  public actionList: any;
  public user: any;
  public stringToArray = [];
  public units: any;
  public finalStr: any;
  public des: any;
  public description: any;
  public addBuy = [];
  tooltip: any;
  firstSignup: any;
  signupStatus: any;
  terms: any;
  imageModel: NgbModalRef;
  constructor(
    private ngxService: NgxUiLoaderService,
    public router: Router,
    private modalService: NgbModal,
    private zone: NgZone,
    public fb: FormBuilder,
    public authenticationService: AuthenticationService
  ) {
    // this.authenticationService.SetSharindFlag.subscribe(res => {
    //   console.log(res)
    //   this.firstSignup = res
    // })
  }
  // ngOnInit(): void {
  //   this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
  //   this.firstSignup = JSON.parse(localStorage.getItem('mystatus')) || false;

  //   this.signupStatus = this.firstSignup.status || false;
  //   this.form = this.fb.group({
  //     terms: ['', []],
  //     termsAccepted: [false, Validators.requiredTrue],
  //     actions: this.fb.array([this.createAction()]),
  //   });
  //   let infot = JSON.parse(localStorage.getItem('merchant_user'));
  //   this.description = localStorage.getItem('description') || '';
  //   this.terms = localStorage.getItem('terms') || '';
  //   if (this.terms) {
  //     this.form.controls['terms'].setValue(this.terms);
  //   }

  //   if (this.description) {
  //     let des = this.description.split('\n');
  //     if (des[1]) {
  //       this.form.controls['termsAndConditions'].setValue(des[1]);
  //     }
  //     let test = des[0].split(/[ ,]+/);
  //     let arr = test.filter((val) => val !== 'and');
  //     this.addBuy = this.chunkArray(arr, 3);
  //     this.actions = this.form.get('actions') as FormArray;
  //     this.actions.removeAt(0);
  //     for (let i = 0; i < this.addBuy.length; i++) {
  //       let offer = this.addBuy[i][0];
  //       let value = this.addBuy[i][1];
  //       var dollar = value.match(/^\$/);
  //       var hash = value.match(/^\#/);
  //       var percent = value.match(/\%/);
  //       let point = value.includes('points');
  //       let name = this.addBuy[i][2];
  //       let unit = '';
  //       let amount: number | string = '';
  //       if (dollar && dollar.length) {
  //         amount = parseFloat(value.replace(/[^0-9.]/gi, ''));
  //         unit = 'Currency $';
  //       } else if (hash && hash.length) {
  //         amount = parseInt(value.replace(/[^0-9]/gi, ''), 10);
  //         unit = 'Quantity #';
  //       } else if (percent && percent[0]) {
  //         amount = parseFloat(value.replace(/[^0-9.]/gi, ''));
  //         unit = 'Percent %';
  //       } else if (point) {
  //         amount = parseInt(value.replace(/[^0-9]/gi, ''), 10);
  //         unit = 'Ravel Points';
  //       }
  //       // this.fb.group({});
  //       this.actions = this.form.get('actions') as FormArray;
  //       this.actions.push(
  //         this.fb.group({
  //           offer: offer,
  //           unit: unit,
  //           value: amount,
  //           name: name,
  //         })
  //       );
  //     }
  //   }

  //   this.actionList = [
  //     { value: 'Buy', name: 'Buy' },
  //     { value: 'Get', name: 'Get' },
  //     { value: 'Spend', name: 'Spend' },
  //     { value: 'Redeem', name: 'Redeem' },
  //     { value: 'Custom', name: 'Custom' },
  //   ];
  //   this.units = [
  //     { value: 'Quantity #', name: 'Quantity #' },
  //     { value: 'Currency $', name: 'Currency $' },
  //     { value: 'Percent %', name: 'Percent %' },
  //     { value: 'Ravel Points', name: 'Ravel Points' },
  //   ];
  // }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
    this.firstSignup = JSON.parse(localStorage.getItem('mystatus')) || false;

    this.signupStatus = this.firstSignup.status || false;
    this.form = this.fb.group({
      terms: ['', []],
      termsAccepted: [false, []], // ab mandatory nahi hai
      ravelPointsRequired: [null, [Validators.required, Validators.min(0), Validators.max(500)]], // naya field
      actions: this.fb.array([this.createAction()]),
    });
    let infot = JSON.parse(localStorage.getItem('merchant_user'));
    this.description = localStorage.getItem('description') || '';
    this.terms = localStorage.getItem('terms') || '';
    if (this.terms) {
      this.form.controls['terms'].setValue(this.terms);
    }

    if (this.description) {
      let des = this.description.split('\n');
      if (des[1]) {
        this.form.controls['termsAndConditions'].setValue(des[1]);
      }
      let test = des[0].split(/[ ,]+/);
      let arr = test.filter((val) => val !== 'and');
      this.addBuy = this.chunkArray(arr, 3);
      this.actions = this.form.get('actions') as FormArray;
      this.actions.removeAt(0);
      for (let i = 0; i < this.addBuy.length; i++) {
        let offer = this.addBuy[i][0];
        let value = this.addBuy[i][1];
        let name = this.addBuy[i][2];
        let unit = '';
        let amount: number | string = '';

        // Check for unit prefixes
        const dollar = value.match(/^\$/);
        const hash = value.match(/^#/); // Updated to match # instead of \#
        const percent = value.match(/%$/); // Match % at the end
        const point = value.includes('points');

        if (dollar) {
          amount = parseFloat(value.replace(/[^0-9.]/g, '')); // Extract number
          unit = 'Currency $';
        } else if (hash) {
          amount = parseInt(value.replace(/[^0-9]/g, ''), 10); // Extract number
          unit = 'Quantity #';
        } else if (percent) {
          amount = parseFloat(value.replace(/[^0-9.]/g, '')); // Extract number
          unit = 'Percent %';
        } else if (point) {
          amount = parseInt(value.replace(/[^0-9]/g, ''), 10); // Extract number
          unit = 'Ravel Points';
        } else if (!isNaN(parseFloat(value)) && isFinite(parseFloat(value))) {
          // If value is a number, default to Quantity #
          amount = parseInt(value, 10);
          unit = 'Quantity #';
        } else {
          amount = '';
          unit = '';
        }

        this.actions.push(
          this.fb.group({
            offer: offer,
            unit: unit,
            value: amount, // Set as number
            name: name,
          })
        );
      }
    }

    this.actionList = [
      { value: 'Buy', name: 'Buy' },
      { value: 'Get', name: 'Get' },
      { value: 'Spend', name: 'Spend' },
      { value: 'Redeem', name: 'Redeem' },
      { value: 'Custom', name: 'Custom' },
    ];
    this.units = [
      { value: 'Quantity #', name: 'Quantity #' },
      { value: 'Currency $', name: 'Currency $' },
      { value: 'Percent %', name: 'Percent %' },
      { value: 'Ravel Points', name: 'Ravel Points' },
    ];
  }

  onTermsAcceptedChange() {
    this.form.controls['termsAccepted'].markAsTouched();
  }

  openImageModal(image) {
    this.imageModel = this.modalService.open(image, { centered: true });
  }

  closeModal() {
    this.imageModel.close();
  }

  addCategory() {
    this.tooltip = false;
    this.actions = this.form.get('actions') as FormArray;
    this.actions.push(this.createAction());
  }
  createAction() {
    return this.fb.group({
      offer: '',
      unit: '',
      value: [null],
      name: '',
      terms: '',
    });
  }

  removeCategory(index) {
    this.actions.removeAt(index);
  }

  openModal(content) {
    this.submitted = true;
    this.form.markAllAsTouched();

    if (this.form.valid) {
      Swal.fire({
        title: 'Does your discount qualify for Kingdom Partner status?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.controls['termsAccepted'].setValue(true);
        } else if (result.isDenied) {
          this.form.controls['termsAccepted'].setValue(false);
        } else {
          return;
        }

        this.save(this.form.value);
        this.actionModel = this.modalService.open(content, {
          backdrop: 'static',
          keyboard: false,
        });
      });
    }
  }

  // save(value) {
  //   let data = value.actions;
  //   var discoutStrArr = [];
  //   for (let i = 0; i < data.length; i++) {
  //     var discoutStr = data[i].offer;
  //     var val;
  //     var amount;
  //     if (data[i].unit == 'Quantity #') {
  //       amount = data[i].value;
  //     } else if (data[i].unit == 'Currency $') {
  //       amount = '$' + data[i].value;
  //     } else if (data[i].unit == 'Ravel Points') {
  //       amount = data[i].value + 'points';
  //     } else if (data[i].unit == 'Percent %') {
  //       amount = data[i].value + '%';
  //     }
  //     var name = data[i].name;
  //     var str = discoutStr.concat(' ', amount);
  //     var mainstr = str.concat(' ', name);

  //     discoutStrArr.push(mainstr);
  //   }
  //   this.finalStr = '';
  //   // if(data.offer != null) {
  //   this.finalStr = discoutStrArr.join(' and ');

  //   if (value.termsAndConditions != null && value.termsAndConditions != '') {
  //     this.finalStr = this.finalStr;
  //   }
  // }

  save(value) {
    let data = value.actions;
    var discoutStrArr = [];
    for (let i = 0; i < data.length; i++) {
      var discoutStr = data[i].offer || '';
      let amount = '';
      const name = data[i].name || '';
      const val = data[i].value != null ? data[i].value : '';

      // Skip invalid entries
      if (!discoutStr || !name) {
        continue;
      }

      // Set amount with unit prefix
      if (data[i].unit === 'Quantity #') {
        amount = '#' + val; // Add # prefix for Quantity
      } else if (data[i].unit === 'Currency $') {
        amount = '$' + val;
      } else if (data[i].unit === 'Ravel Points') {
        amount = val + 'points';
      } else if (data[i].unit === 'Percent %') {
        amount = val + '%';
      } else {
        amount = val; // Fallback
      }

      var str = discoutStr.concat(' ', amount);
      var mainstr = str.concat(' ', name);
      discoutStrArr.push(mainstr);
    }
    this.finalStr = discoutStrArr.length > 0 ? discoutStrArr.join(' and ') : '';
  }

  saveData() {
    localStorage.removeItem('description');
    localStorage.removeItem('terms');
    localStorage.removeItem('termsAccepted');
    localStorage.removeItem('ravelPointsRequired');
    
    localStorage.setItem('description', this.finalStr);
    localStorage.setItem('terms', this.terms);
    localStorage.setItem('termsAccepted', this.form.value.termsAccepted);
    localStorage.setItem('ravelPointsRequired', this.form.value.ravelPointsRequired);
    this.router.navigate(['/perpetual-add']);
    this.actionModel.close();
  }
  redirect() {
    this.router.navigate(['/dashboard']);
  }
  chunkArray(myArray, chunk_size) {
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      let myChunk = myArray.slice(index, index + chunk_size);
      // Do something if you want with the group
      tempArray.push(myChunk);
    }
    return tempArray;
  }
  mouseover() {
    this.tooltip = true;
  }
  leave() {
    // Keep tooltip open until explicitly closed
  }

  closeTooltip(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.tooltip = false;
  }

  setTerms(event: any) {
    this.terms = event.target.value;
  }
}
